import React, { forwardRef } from "react";
import { SliderThumb } from "@mui/material/Slider";

const TestIdSliderThumb = forwardRef(function TestIdSliderThumb({ getTestId, ...props }, ref) {
  return <SliderThumb ref={ref} {...props} data-testid={getTestId?.(props["data-index"])} />;
});

const TestIdSliderInput = forwardRef(function TestIdSliderInput(
  { getTestId, ownerState, ...props },
  ref
) {
  return <input ref={ref} {...props} data-testid={getTestId?.(props["data-index"])} />;
});

export function sliderTestIdSlots(base, getThumbName) {
  if (!base) return {};
  const stem = (i) => {
    const name = getThumbName?.(i);
    return name ? `${base}-${name}` : base;
  };
  return {
    slots: { thumb: TestIdSliderThumb, input: TestIdSliderInput },
    slotProps: {
      thumb: { getTestId: (i) => `${stem(i)}-thumb` },
      input: { getTestId: (i) => `${stem(i)}-input:range` },
    },
  };
}
